import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    retoma_potencial: null,
    tp_retoma: null,
    placa_retoma: null,
    credito_potencial: null,
    oferta_cliente: 0
};
const mutations = {
    updateField,
    updatePotencial: (state, payload) => {
        var size = Object.keys(payload.cliente_potencial).length;
        if (size > 0) {
            state.retoma_potencial = payload.cliente_potencial.retoma_potencial;
            state.tp_retoma = payload.cliente_potencial.tp_retoma;
            state.placa_retoma = payload.cliente_potencial.placa_retoma;
            state.credito_potencial = payload.cliente_potencial.credito_potencial;
            state.oferta_cliente = payload.cliente_potencial.oferta_cliente;
        }
    }
};

const getters = {
    getField
};

const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
